import React, { useEffect, useState } from 'react';
import { getClassStudents, getSubjectDetails } from '../../../redux/sclassRelated/sclassHandle';
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
  
 import axios from 'axios';

 

const ViewSubject = () => {
  const navigate = useNavigate();
  const params = useParams();
  const dispatch = useDispatch();
 
  const { classID, subjectID } = params;

  const [  setAssignedTeacher] = useState('Not Assigned');

  useEffect(() => {
    dispatch(getSubjectDetails(subjectID, "Subject"));
    dispatch(getClassStudents(classID));
    // Fetch teacher assigned to this subject via class assignments
    const baseUrl = process.env.REACT_APP_BASE_URL ;
    axios.get(`${baseUrl}/Class/Assignments/${classID}`)
      .then(res => {
        const assignments = res.data;
        if (Array.isArray(assignments)) {
          const match = assignments.find(a =>
            a.subjects?.some(s => s._id === subjectID || s === subjectID)
          );
          if (match) setAssignedTeacher(match.teacher?.name || 'Not Assigned');
        }
      })
      .catch(() => {});
  }, [dispatch, subjectID, classID]);

  
 
 
};

export default ViewSubject;

 